<template>
  <div>
    <!-- 样式1 -->
    <div v-if="styleType === '1'" class="music-view" @click="toggle">
      <img
        src="https://ossfastmake.mustke.com/wenjuan/tupian/music-1769330643047.png"
        class="music-image"
      />
      <div class="music-time">{{ formatTime(remainTime) }}</div>
      <img
        v-if="showDel"
        src="https://ossfastmake.mustke.com/wenjuan/tupian/关闭(1)-1770804336222.svg"
        class="del"
        @click.stop="handleDeleteAudio(param)"
      />
    </div>

    <!-- 样式2 -->
    <div v-else class="audio-item">
      <img
        v-if="showDel"
        src="https://ossfastmake.mustke.com/wenjuan/tupian/关闭(1)-1770804336222.svg"
        class="del"
        @click.stop="handleDeleteAudio(param)"
      />
      <div class="btn" @click="toggle">
        <i v-if="isPlaying" class="el-icon-video-pause"></i>
        <i v-else class="el-icon-video-play"></i>
      </div>

      <!-- 进度条 -->
      <div
        class="progress-box"
        :style="{ width: progressWidth + 'px' }"
        @click="progressClick"
      >
        <input
          type="range"
          v-model="progress"
          max="100"
          @input="handleSeek"
          class="slider"
        />
      </div>

      <div class="time">{{ currentFormat }} / {{ totalFormat }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AudioPlayer",
  props: {
    src: String,
    title: String,
    playingId: [String, Number],
    param: Array,
    time: {
      type: Number,
      default: 0,
    },
    styleType: {
      type: String,
      default: "1",
    },
    showDel: {
      type: Boolean,
      default: true,
    },
    progressWidth: {
      type: Number,
      default: 370,
    },
  },
  data() {
    return {
      audio: null,
      isPlaying: false,
      duration: 0,
      currentTime: 0,
      progress: 0,
    };
  },
  computed: {
    remainTime() {
      if (!this.duration) return "00:00:00";
      let left = this.duration - this.currentTime;
      if (left < 0) left = 0;
      const hours = Math.floor(left / 3600);
      const minutes = Math.floor((left % 3600) / 60);
      const secs = Math.floor(left % 60);
      return [hours, minutes, secs]
        .map((v) => (v < 10 ? "0" + v : v))
        .join(":");
    },
    currentFormat() {
      return this.doFormat(this.currentTime);
    },
    totalFormat() {
      return this.doFormat(this.duration);
    },
  },
  watch: {
    playingId(newId) {
      if (newId !== this.title && this.isPlaying) {
        this.audio.pause();
        this.isPlaying = false;
        this.currentTime = 0;
        this.progress = 0;
      }
    },
    time(newTime) {
      this.duration = newTime;
    },
    currentTime(val) {
      if (this.duration) {
        this.progress = (val / this.duration) * 100;
      }
    },
  },
  mounted() {
    this.audio = new Audio(this.src);
    this.audio.onloadedmetadata = () => {
      this.duration = this.audio.duration;
    };
    this.audio.ontimeupdate = () => {
      this.currentTime = this.audio.currentTime;
    };
    this.audio.onended = () => {
      this.isPlaying = false;
      this.currentTime = 0;
      this.progress = 0;
      this.$emit("play", "");
    };
  },
  methods: {
    toggle() {
      if (!this.audio) return;
      if (this.isPlaying) {
        this.audio.pause();
        this.isPlaying = false;
      } else {
        this.$emit("play", this.title);
        this.audio.play();
        this.isPlaying = true;
      }
    },
    handleSeek() {
      if (!this.duration) return;
      const seekTime = (this.progress / 100) * this.duration;
      this.audio.currentTime = seekTime;
    },
    progressClick(e) {
      const rect = e.currentTarget.getBoundingClientRect();
      const pos = (e.clientX - rect.left) / rect.width;
      const seekTime = pos * this.duration;
      this.audio.currentTime = seekTime;
      this.progress = pos * 100;
    },
    doFormat(s) {
      s = Math.floor(s);
      const m = Math.floor(s / 60);
      const sec = s % 60;
      return `${m.toString().padStart(2, "0")}:${sec
        .toString()
        .padStart(2, "0")}`;
    },
    formatTime(s) {
      return s;
    },

    // ====================== 【终极删除立刻停】 ======================
    handleDeleteAudio(param) {
      try {
        if (this.audio) {
          this.audio.pause();
          this.audio.src = "";
          this.audio.load();
          this.audio = null;
        }
      } catch (e) {}

      this.isPlaying = false;
      this.$emit("play", "");
      this.$emit("delete-audio", param);
    },
  },
  beforeDestroy() {
    try {
      if (this.audio) {
        this.audio.pause();
        this.audio.src = "";
        this.audio.load();
      }
    } catch (e) {}
  },
};
</script>

<style lang="scss" scoped>
.music-view {
  width: 260px;
  height: 46px;
  background: #ffffff;
  border: 1.08px solid #eeeeee;
  border-radius: 23px;
  display: flex;
  align-items: center;
  margin-top: 20px;
  position: relative;

  .del {
    position: absolute;
    width: 19px;
    height: 19px;
    top: -5px;
    right: -5px;
  }
}

.music-image {
  width: 32px;
  height: 40px;
  margin-left: 21px;
}

.music-time {
  font-size: 30px;
  font-weight: 600;
  color: #656374;
  line-height: 16px;
  margin-left: 29px;
}

.audio-item {
  width: 100%;
  display: flex;
  align-items: center;
  height: 46px;
  background-color: #03ce66;
  border-radius: 23px;
  padding: 0 27px;
  box-sizing: border-box;
  position: relative;
  gap: 14px;
}

.btn {
  color: #ffffff;
  font-size: 18px;
  cursor: pointer;
  flex-shrink: 0;
}

.time {
  color: #ffffff;
  font-size: 16px;
  white-space: nowrap;
  flex-shrink: 0;
}

.progress-box {
  display: flex;
  align-items: center;
  cursor: pointer;
  width: 100%;
}

.slider {
  width: 100% !important;
  height: 6px !important;
  display: block !important;
  appearance: none;
  background: rgba(255, 255, 255, 0.4);
  border-radius: 3px;
  outline: none;
}

.slider::-webkit-slider-thumb {
  appearance: none;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #fff;
  cursor: pointer;
}

.del {
  position: absolute;
  width: 19px;
  height: 19px;
  top: -5px;
  right: -5px;
}
</style>



// WEBPACK FOOTER //
// src/components/AudioItem/index.vue